// Flat items render as top-level links.
// Items with a `children` array render as a collapsible SubMenu group.
export const navItems = [
  {
    category: "Overview",
    iClass: "bi bi-speedometer2",
    url: "/admin"
  },
  {
    group: "Users",
    iClass: "bi bi-people-fill",
    children: [
      { category: "All Agents",    iClass: "bi bi-person-badge-fill",  url: "/admin/agents" },
      { category: "All Merchants", iClass: "bi bi-shop",               url: "/admin/merchants" },
      { category: "Sales Admins",  iClass: "bi bi-shield-person-fill", url: "/admin/sales-admins" },
      { category: "Sectors",       iClass: "bi bi-map-fill",           url: "/admin/sectors" },
    ]
  },
  {
    group: "Finance",
    iClass: "bi bi-cash-stack",
    children: [
      {
        group: "Paystack",
        iClass: "bi bi-credit-card",
        children: [
          { category: "Wallets",      iClass: "bi bi-wallet2",                  url: "/admin/wallets" },
          { category: "Payments",     iClass: "bi bi-credit-card",              url: "/admin/payments" },
          { category: "Transactions", iClass: "bi bi-list-ul",                  url: "/admin/payments/transactions" },
          { category: "Settlements",  iClass: "bi bi-bank",                     url: "/admin/payments/settlements" },
          { category: "Disputes",     iClass: "bi bi-shield-exclamation",       url: "/admin/payments/disputes" },
          { category: "Refunds",      iClass: "bi bi-arrow-counterclockwise",   url: "/admin/payments/refunds" },
          { category: "Earnings",     iClass: "bi bi-graph-up-arrow",           url: "/admin/earnings" },
          { category: "Payouts",      iClass: "bi bi-cash-coin",                url: "/admin/payouts" },
        ]
      },
      {
        group: "SeerBit",
        iClass: "bi bi-wallet2",
        children: [
          { category: "Wallets",           iClass: "bi bi-wallet2",         url: "/admin/seerbit/wallets" },
          { category: "Tier Upgrades",      iClass: "bi bi-shield-check",    url: "/admin/seerbit/tier-requests" },
          { category: "Business Upgrades",  iClass: "bi bi-building-check",  url: "/admin/seerbit/business-requests" },
          { category: "POS Requests",       iClass: "bi bi-credit-card",     url: "/admin/seerbit/pos-requests" },
          { category: "Fee Revenue",        iClass: "bi bi-graph-up-arrow",  url: "/admin/seerbit/fees" },
          { category: "Limits & Fees",      iClass: "bi bi-sliders",         url: "/admin/seerbit/settings" },
        ]
      },
    ]
  },
  {
    group: "Subscriptions",
    iClass: "bi bi-card-list",
    children: [
      { category: "Plans",           iClass: "bi bi-card-list", url: "/admin/subscriptions" },
      { category: "Merchant Subs",   iClass: "bi bi-people",    url: "/admin/subscriptions/merchants" },
    ]
  },
  {
    category: "Feedbacks",
    iClass: "bi bi-chat-left-text",
    url: "/admin/feedbacks"
  },
  {
    group: "Support",
    iClass: "bi bi-headset",
    children: [
      { category: "Support Tickets", iClass: "bi bi-ticket-perforated-fill", url: "/admin/support-tickets" },
      { category: "App Feedbacks",   iClass: "bi bi-star-fill",              url: "/admin/app-feedbacks" },
    ]
  },
];
